<template>
  <md-list>
    <template v-for="(item, index) in navItems">
      <md-list-item
        :key="index"
        :to="item.link"
      >
        {{ item.name }}
      </md-list-item>
    </template>
    <md-list-item
      href="http://kampalabiennale.org"
      target="_blank"
    >
      KAB WEBSITE
    </md-list-item>
  </md-list>
</template>

<script>
import items from "./routesConfig";
export default {
  name: "SecondaryNavBar",
  data() {
    return {
      navItems: items
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
